import request from '@/config/axios'

export interface MallShareConfigVO {
  id?: number
  shareTitle?: string
  shareIcon?: string
  shareDesc?: string
  landPath?: string
  goodsDetailShareEnabled?: boolean
  goodsDetailShareText?: string
}

export const getMallShareConfig = async () => {
  return await request.get({ url: `/trade/mall-share-config/get` })
}

export const saveMallShareConfig = async (data: MallShareConfigVO) => {
  return await request.put({ url: `/trade/mall-share-config/save`, data })
}
